import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAutomation } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { UpdateDmAutomationReq } from '@/types/dmAutomation';

interface Variables {
    id: string;
    body: UpdateDmAutomationReq;
}

export const useUpdateAutomation = () => {
    const queryClient = useQueryClient();
    return useMutation<void, unknown, Variables>({
        mutationFn: ({ id, body }) => updateAutomation(id, body),
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.list() });
            queryClient.invalidateQueries({ queryKey: ['dm-automation', id] });
        },
    });
};
